// extracted by mini-css-extract-plugin
export var footer = "_p5-5";
export var fulfillmentInput = "_p5-0";
export var shipDateInput = "_p5-1";
export var shipmentModal = "_p5-2";
export var shipmentModalContent = "_p5-3";
export var tableContainer = "_p5-4";